import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

export const BulkUserRemovalModal = ({
  error = null,
  userIds = [],
  onUsersRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const onConfirm = useCallback(() => {
    onUsersRemoved(userIds);
  }, [onUsersRemoved, userIds])

  return (
    <ConfirmationDialog
      title="Delete Users"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="bulk-delete-user-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1">
        <Label>
          The selected users will be deleted from Wallaroo, any records referencing the users will show as “Deleted User” Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the user(s). Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default BulkUserRemovalModal;
